import { render, staticRenderFns } from "./problem-form.vue.js?vue&type=template&id=9a12af74!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./problem-form.vue?vue&type=template&id=9a12af74"
import script from "./problem-form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./problem-form.vue?vue&type=script&lang=js"
export * from "./problem-form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./problem-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports